import {ROOT_URL} from './dataSource.js';
import JsEncrypt from 'jsencrypt';

export function setNewPinCode(pinCode) {
  const ans = fetch(ROOT_URL+'/auth/get_crypt_session/', {
    method: 'GET',
  }).then(async function(result) {
    const jsonData = await result.json();

    const cryptSession = jsonData.session;
    const cryptPublicKey = jsonData.public_key;

    const cryptData = {pin_code: pinCode};

    const en = new JsEncrypt();
    en.setPublicKey(cryptPublicKey);
    const encrypted = en.encrypt(JSON.stringify(cryptData));

    return fetch(
        ROOT_URL+'/auth/set_new_pin_code/',
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'ENCRYPTED-DATA': encrypted,
            'CRYPT-SESSION': cryptSession,
          },
        },
    );
  });

  return ans;
}

export function deletePinCode(pinSession) {
  const ans = fetch(ROOT_URL+'/auth/get_crypt_session/', {
    method: 'GET',
  }).then(async function(result) {
    const jsonData = await result.json();

    const cryptSession = jsonData.session;
    const cryptPublicKey = jsonData.public_key;

    const cryptData = {pin_session: pinSession};

    const en = new JsEncrypt();
    en.setPublicKey(cryptPublicKey);
    const encrypted = en.encrypt(JSON.stringify(cryptData));

    return fetch(
        ROOT_URL+'/auth/delete_pin_code/',
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'ENCRYPTED-DATA': encrypted,
            'CRYPT-SESSION': cryptSession,
          },
        },
    );
  });

  return ans;
}
